export const contractDurations = [
    { value: null, label: 'Geen voorkeur' },
    { value: '1', label: 'Maandelijks' },
    { value: '12', label: '1 jaar' },
    { value: '24', label: '2 jaar' },
    { value: '36', label: '3 jaar' },
];

export const contractTypes = [
    { value: 'dynamic', label: 'Dynamisch' },
    { value: '1', label: 'Maandelijks' },
    { value: '12', label: '1 jaar vast' },
    { value: '24', label: '2 jaar vast' },
    { value: '36', label: '3 jaar vast' },
];

export const contractTypesWithoutDynamic = [
    { value: '12', label: '1 jaar vast', flag: '(Meest gekozen)' },
    { value: '24', label: '2 jaar vast' },
    { value: '36', label: '3 jaar vast' },
    { value: '1', label: 'Variabel' },
];

export const electricityGreen = [
    { value: null, label: 'Geen voorkeur' },
    { value: 'nl', label: 'Groen uit Nederland' },
    { value: 'compensated', label: 'Groen uit Europa' },
    { value: 'gray', label: 'Grijze stroom' },
];
export const sustainabilityScores = [
    { value: 8, label: 'Groenscore A' },
    { value: 6, label: 'Groenscore B of beter' },
    { value: 0, label: 'Geen voorkeur' },
];

export const providerGreen = [
    { value: null, label: 'Geen voorkeur' },
    { value: 'low', label: '1 t/m 5' },
    { value: 'med', label: '5.5 t/m 7.5' },
    { value: 'high', label: '7.5+' },
];

export const sortModes = [
    { value: 'price', label: 'Goedkoopste eerst' },
    { value: 'monthly_installment', 'label': 'Laagste termijnbedrag' },
    { value: 'sustainability', label: 'Hoogste groenscore' },
    { value: 'discount', label: 'Hoogste cashback' },
];

// TODO: Make these dynamic:
export const providers = [
    {
        label: 'Budget Energie',
        value: 'budget-energie',
    },
    {
        label: 'Coolblue Energie',
        value: 'coolblue',
    },
    {
        label: 'Delta',
        value: 'delta',
    },
    {
        label: 'Eneco',
        value: 'eneco',
    },
    {
        label: 'EnergieDirect',
        value: 'energiedirect',
    },
    {
        label: 'ENGIE',
        value: 'engie',
    },
    {
        label: 'Essent',
        value: 'essent',
    },
    {
        label: 'Frank Energie',
        value: 'frank-energie',
    },
    {
        label: 'Gewoon Energie',
        value: 'gewoon-energie',
    },
    {
        label: 'Greenchoice',
        value: 'greenchoice',
    },
    {
        label: 'Innova Energie',
        value: 'innova',
    },
    {
        label: 'Mega',
        value: 'mega',
    },
    {
        label: 'NextEnergy',
        value: 'nextenergy',
    },
    {
        label: 'Noord Energie',
        value: 'noord-energie',
    },
    {
        label: 'Oxxio',
        value: 'oxxio',
    },
    {
        label: 'PowerPeers',
        value: 'powerpeers',
    },
    {
        label: 'Pure Energie',
        value: 'pure-energie',
    },
    {
        label: 'Tibber',
        value: 'tibber',
    },
    {
        label: 'UnitedConsumers',
        value: 'united-consumers',
    },
    {
        label: 'Vandebron',
        value: 'vandebron',
    },
    {
        label: 'Vattenfall',
        value: 'nuon',
    },
    {
        label: 'Zonneplan',
        value: 'zonneplan',
    },
];

export const extraProviders = [
    {
        label: 'HVC energie',
        value: 'hvc-energie',
    },
    {
        label: 'EnergyZero',
        value: 'energyzero',
    },
];
